import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  AUTHORIZED_CHECK,
  AUTHORIZED_LOGIN,
  AUTHORIZED_LOGOUT,
  AUTHORIZED_REFRESH,
  AUTHORIZED_REGISTRATION,
  FORGOT_PASSWORD, LOAD_NOTIFICATION,
} from './actions';
import {
  LOCAL_STORAGE_AUTHORIZED_KEY,
  LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT,
} from '../../configs/names';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { AUTHORIZED_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';
import AuthorizedDTO from '../../dto/AuthorizedDTO';
import {
  clearStoredAuth,
  getStoredAccessToken,
  getStoredRefreshToken,
  setStoredAccessToken,
  setStoredRefreshToken,
} from './authSession';

const getUser = () => {
  try {
    const result = window.localStorage.getItem(LOCAL_STORAGE_AUTHORIZED_KEY);
    return result ? JSON.parse(result) : {};
  } catch (e) {
    return {};
  }
};

const token = getStoredAccessToken();
const refreshToken = getStoredRefreshToken();
// if (!client.id || !token) {
if (!token) {
  clearStoredAuth();
}

const initialState = {
  loggedIn: !!token,
  // loggedIn: true,
  loginProcess: false,
  authorizedData: getUser(),
  token,
  refreshToken,
  loadingForgotPassword: false,
  notificationMeta: {},
  notification: [],
  loadingNotification: false,
};

const reducer = handleActions({
  ...createOperationStateReducer(AUTHORIZED_MODULE + FORGOT_PASSWORD, 'loadingForgotPassword'),
  ...createLoadListReducerWithBegin(AUTHORIZED_MODULE + LOAD_NOTIFICATION, 'notification', 'loadingNotification'),
  [AUTHORIZED_MODULE + AUTHORIZED_LOGIN]: state => {
    clearStoredAuth();
    return {
      ...state,
      token: null,
      refreshToken: null,
      authorizedData: {},
      loggedIn: false,
      loginProcess: true,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_LOGIN + SUCCESSFUL]: (state, action) => {
    const { access, refresh, profile } = action.payload;
    setStoredAccessToken(access);
    setStoredRefreshToken(refresh);
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT, new Date().getTime());
    return {
      ...state,
      token: access,
      refreshToken: refresh || null,
      loggedIn: !!access,
      loginProcess: false,
      authorizedData: profile,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_REFRESH + SUCCESSFUL]: (state, action) => {
    const tokenData = typeof action.payload === 'string' ? { access: action.payload } : action.payload;
    const access = tokenData?.access;
    const refresh = tokenData?.refresh || state.refreshToken;
    setStoredAccessToken(access);
    setStoredRefreshToken(refresh);
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT, new Date().getTime());
    return {
      ...state,
      token: access,
      refreshToken: refresh || null,
      loggedIn: !!access,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_LOGIN + FAILED]: state => {
    clearStoredAuth();
    return {
      ...state,
      authorizedData: {},
      token: null,
      refreshToken: null,
      loggedIn: false,
      loginProcess: false,
      loadingAuthorizedCheck: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_CHECK]: (state, action) => ({
    ...state,
    loadingAuthorizedCheck: true,
  }),
  [AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL]: (state, action) => {
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_KEY, JSON.stringify(action.payload));
    return {
      ...state,
      authorizedData: action.payload,
      loggedIn: true,
      loadingAuthorizedCheck: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_CHECK + FAILED]: (state, action) => ({
    ...state,
    authorizedData: action.payload,
    loggedIn: true,
    loadingAuthorizedCheck: false,
  }),
  [AUTHORIZED_MODULE + AUTHORIZED_LOGOUT + SUCCESSFUL]: state => {
    clearStoredAuth();
    return {
      ...state,
      authorizedData: {},
      token: null,
      refreshToken: null,
      loggedIn: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_REGISTRATION]: state => ({
    ...state,
    loggedIn: false,
  }),
}, initialState);

export default reducer;

export const getAuthorizedData = createSelector([state => state[AUTHORIZED_MODULE]], state => new AuthorizedDTO(state));

export const getLoginProcess = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => state.loginProcess || false,
);

export const getClientPersonalData = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => state.authorizedData,
);

export const getNotificationData = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => ({
    notificationMeta: state.notificationMeta,
    notification: state.notification,
    loadingNotification: state.loadingNotification,
  }),
);
